export const ProjectConfigOverride = {
  api_url: "https://api.especialistaenheridas.cl",
};